import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { CookieService } from 'ngx-cookie-service';
import { PrimeNG } from 'primeng/config';

const PRIMENG_LOCALE: Record<string, object> = {
  th: {
    firstDayOfWeek: 0,
    dayNames: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
    dayNamesShort: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
    dayNamesMin: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
    monthNames: [
      'มกราคม',
      'กุมภาพันธ์',
      'มีนาคม',
      'เมษายน',
      'พฤษภาคม',
      'มิถุนายน',
      'กรกฎาคม',
      'สิงหาคม',
      'กันยายน',
      'ตุลาคม',
      'พฤศจิกายน',
      'ธันวาคม'
    ],
    monthNamesShort: [
      'ม.ค.',
      'ก.พ.',
      'มี.ค.',
      'เม.ย.',
      'พ.ค.',
      'มิ.ย.',
      'ก.ค.',
      'ส.ค.',
      'ก.ย.',
      'ต.ค.',
      'พ.ย.',
      'ธ.ค.'
    ],
    today: 'วันนี้',
    clear: 'ล้าง'
  },
  en: {
    firstDayOfWeek: 0,
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear'
  }
};

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, NgxSpinnerComponent, TranslatePipe],
  template: `
    <router-outlet></router-outlet>

    <ngx-spinner #spinner bdColor="#000000CC" type="ball-beat"
      ><p style="color: white; font-size: 1.25rem">
        {{ 'common.label.system_is_in_progress' | translate }}
      </p></ngx-spinner
    >
  `
})
export class AppComponent {
  private translate = inject(TranslateService);
  private cookieService = inject(CookieService);
  private primeNG = inject(PrimeNG);

  constructor() {
    this.translate.addLangs(['th', 'en']);
    this.translate.setFallbackLang('en');
    const lang = this.cookieService.get('lang') || 'th';
    this.translate.use(lang);
    this._applyPrimeNGLocale(lang);

    this.translate.onLangChange.subscribe(e => this._applyPrimeNGLocale(e.lang));
  }

  private _applyPrimeNGLocale(lang: string): void {
    this.primeNG.setTranslation(PRIMENG_LOCALE[lang] ?? PRIMENG_LOCALE['en']);
  }
}
